import { c as _c } from "react/compiler-runtime";
import { Typography } from '@repo/ui/Typography';
import type { Likelihood } from '@/features/approval-odds/constants';
import { approvalOddsSlotRecipe } from './styles';
type CardsApprovalLabelProps = {
  label: Likelihood;
};
export const CardsApprovalLabel = t0 => {
  const $ = _c(8);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = approvalOddsSlotRecipe({
      likelihood: label
    });
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    label: labelClass
  } = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      fontSize: "[13px]"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <Typography as="span" variant="accent.small" css={t2}>{label}</Typography>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== labelClass || $[6] !== t3) {
    t4 = <div data-testid="approval-label" className={labelClass}>{t3}</div>;
    $[5] = labelClass;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};